import { Component, OnInit, computed, inject, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BookService } from "../../services/book.service";
import { AuthService, LogService, MessageService, LoadingService } from '../../services'
import { Book } from "../../_models";
import { BookAddEditComponent } from "../book-add-edit/book-add-edit.component";
import { BookReviewComponent } from "../book-review/book-review.component";
import { LoadingComponent } from "../loading/loading.component";

@Component({
    selector: 'kbm-book',
    templateUrl: './book.component.html',
    styleUrls: ['./book.component.scss'],
    standalone: true,
    imports: [
        BookReviewComponent,
        BookAddEditComponent,
        LoadingComponent
    ]
})
export class BookComponent implements OnInit {

  crudStatus: string = 'REVIEW';
  isAuthenticated = computed(() => {
    return this.auth.isLoggedIn();  
  });
  
  book = signal<Book>({
    amazon_id: '',
    title: '',
    type: '',
    authors: [],
    series: []
  });

  auth = inject(AuthService);
  route = inject(ActivatedRoute);
  router = inject(Router);
  bookService = inject(BookService);
  loadingService = inject(LoadingService);
  messageService = inject(MessageService);
  logService = inject(LogService);

  constructor() {
  }


  ngOnInit(): void {
    this.book.set({
      amazon_id: '',
      title: '',
      type: '',
      description: '',
      runningTime: '',
      publisher: '',
      authors: [],
      narrators: [],
      genres: [],
      series: [],
      hasRead: [],
      isInterested: [],
      recommendations: [],
      amazonPageUrl: '',
      coverImageUrl: ''
    });

    this.route.paramMap.subscribe((params) => {
      if (params.get('asin')! == "AddNew") {
        // Add new book
        this.crudStatus = 'CREATE';
        sessionStorage.setItem('crudStatus', this.crudStatus);
      } else {
        // load existing book
        this.crudStatus = 'REVIEW';
        sessionStorage.setItem('crudStatus', this.crudStatus);

        // just call GetBook from bookservice
        this.loadBook(params.get('asin')!)
      }
    });
  }

  onEditClick(e: Event) {
    if (e) {
      sessionStorage.setItem('crudStatus', 'UPDATE');
      this.crudStatus = 'UPDATE';
    }
  }

  handleAddSaveEvent(doneType: string) {

    switch (doneType) {
      case 'ADD':
        this.addBook();
        break;
      case 'SAVE':
        this.updateBook();
        break;
      case 'DELETE':
        this.deleteBook();
        break;  
      case 'CANCEL':
        // reset book to starting value
        this.loadBook(this.book().amazon_id);
        break;
    }
    this.crudStatus = 'REVIEW';
    sessionStorage.setItem('crudStatus', 'REVIEW');
  }

  async loadBook(asin: string) {
    try {
      this.loadingService.loadingOn();
      const bookData = await this.bookService.getBookByAsin(asin);
      this.book.set(bookData);
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
    finally {
      this.loadingService.loadingOff();
    }
  }

  async addBook() {
    try {
      this.loadingService.loadingOn();
      const bookData = await this.bookService.addBook(this.book());
      this.messageService.showMessage('Book Successfully Added', 'success');
    } catch (err) {
      this.messageService.showMessage(`Problem Adding: ${ JSON.stringify(err) }`, 'error');
    }
    finally {
      this.loadingService.loadingOff();
    }
  }

  async updateBook() {
    console.log('update  Book', this.book());
    try {
      this.loadingService.loadingOn();
      const bookData = await this.bookService.updateBook(this.book());
      this.messageService.showMessage('Book Successfully Updated', 'success');
    } catch (err) {
      this.messageService.showMessage(`Problem Saving: ${ JSON.stringify(err) }`, 'error');
    }
    finally {
      this.loadingService.loadingOff();
    }

  }

  async deleteBook() {
    try {
      this.loadingService.loadingOn();
      const bookData = await this.bookService.deleteBook(this.book().amazon_id);
      this.messageService.showMessage(`${ this.book().title } Sucessfully Deleted`, 'success');

    } catch (err) {
      this.messageService.showMessage(`Problem Deleting: ${ JSON.stringify(err) }`, 'error');

    } finally {
      this.loadingService.loadingOff();
    }
  }

}
